exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.legend-sm[data-v-6dc7cf1c] {\n    font-size: 1.2em;\n    font-weight: bold;\n}\n", ""]);

// exports
